import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AButton, AIconButton } from '../atoms';
import { MDatePicker, MLargeInputField } from '../molecules';

export default class ORentPopUp extends React.Component {
	constructor(props) {
		super(props);
		this.bindHandles();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	bindHandles() {
		this.handleWrapperRef = this.handleWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.props.onClose && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.onClose();
		}
	}

	render() {
		return (
			<section className="o-pop-up--rent" ref={this.handleWrapperRef}>
				<header className="o-pop-up--rent-header">
					<h3>
						<FormattedMessage id="RENT_POP_UP.TITLE" defaultMessage="" />
					</h3>
					<p>
						<FormattedMessage id="RENT_POP_UP.BODY" defaultMessage="" />
					</p>
					<AIconButton
						type="close"
						className="no-color close"
						onClick={this.props.onClose}
					/>
				</header>
				<article className="o-pop-up--rent-body">
					<MDatePicker
						onChange={this.props.onDateChange}
						className="o-pop-up--rent-date-picker"
					/>
					<MLargeInputField
						id="liExtraInfo"
						label="RENT_POP_UP.MORE_INFO"
						onChange={this.props.onTextChange}
					/>
				</article>
				<footer className="o-pop-up--rent-footer">
					<AButton
						type="ghost"
						value="RENT_POP_UP.CANCEL"
						onClick={this.props.onClose}
					/>
					<AButton
						value="RENT_POP_UP.ASK_OFFER"
						onClick={this.props.onClick}
					/>
				</footer>
			</section>
		);
	}
}

ORentPopUp.propTypes = {
	onClose: PropTypes.func.isRequired,
	onClick: PropTypes.func.isRequired,
	onDateChange: PropTypes.func.isRequired,
	onTextChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.rent-pop-up.js